import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  height: 500px;
  overflow: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const ContainerWrapper = styled.div``;

const MOBILE = '640px';

export const SearchHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: ${MOBILE}) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const SearchField = styled.div`
  flex: 1 1 auto;
  min-width: 200px;
  max-width: 580px;

  @media (max-width: ${MOBILE}) {
    min-width: 0;
    max-width: none;
  }
`;

export const RowDivider = styled.span`
  margin-left: auto;
  align-self: stretch;
  width: 0;
  min-height: 32px;
  border-left: 1px dashed #d9d9d9;
  flex-shrink: 0;

  @media (max-width: ${MOBILE}) {
    display: none;
  }
`;

export const SectionDivider = styled.div`
  height: 0;
  border-top: 1px dashed #d9d9d9;
`;
